import React, {FC} from 'react';
import {
  Typography,
  Grid,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/GeoViewV2/components/LinksGroupSection/LinksGroupSection.styles';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import {Typography700 } from 'views/rebranded-module/common/components';

const LinksGroupSection:FC<any> = (props) => {
  const { linksGroup, handleLinkClick } = props;
  return (
    <StyledBox mb={6}>
     <Typography700
        variant="h6"
        component="h2"
          mb={3}
        dangerouslySetInnerHTML={{
          __html: linksGroup.title,
        }}
      />
     
          <Grid container spacing={2}>
            {linksGroup.linksList.map((link:any) => (
              <Grid item lg={4} md={12} sm={12} key={link.id}>
                <NavigatorLink
                  href={link.path}
                  translate={false}
                  onClick={() => handleLinkClick(link.path)}>
                  <Typography
                    variant="body3"
                    component="span"
                   color="text.secondary"
                    dangerouslySetInnerHTML={{
                      __html: link.lable,
                    }}
                  />
                </NavigatorLink>
              </Grid>
            ))}
          </Grid>
    </StyledBox>
  );
};

export { LinksGroupSection };
